var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "falcon-upload" },
    [
      _c(
        "el-upload",
        {
          ref: "upload",
          class: ["upload-demo", { no: _vm.fileList.length == _vm.limit }],
          attrs: {
            action: "",
            multiple: _vm.multiple,
            "auto-upload": _vm.auto,
            limit: _vm.limit,
            "list-type": _vm.listStyle,
            "file-list": _vm.fileList,
            accept: _vm.accept,
            "on-preview": _vm.handlePreview,
            "before-upload": _vm.beforeUpload,
            "on-change": _vm.handleChange,
            "before-remove": _vm.beforeRemove,
            "on-remove": _vm.handleRemove,
            "on-exceed": _vm.handleExceed,
          },
        },
        [
          _vm._t("content", function () {
            return [
              !_vm.isFile
                ? _c("i", { staticClass: "el-icon-plus" })
                : _c(
                    "el-button",
                    { attrs: { type: "primary", size: "mini" } },
                    [_vm._v("上传文件")]
                  ),
            ]
          }),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            width: "40%",
            visible: _vm.dialogVisible,
            modal: _vm.isShowModal,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticStyle: { "text-align": "center" } }, [
            _c("img", {
              staticStyle: { "max-width": "100%" },
              attrs: { src: _vm.dialogImageUrl, alt: "图片" },
            }),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }